/* Mobile menu burger toggle */
(function () {
    document.addEventListener("DOMContentLoaded", function () {
        const mobileMenuButton = document.getElementById("mobile-menu-button");
        const mobileMenu = document.getElementById("mobile-menu");

        if (mobileMenuButton && mobileMenu) {
            mobileMenuButton.addEventListener("click", function () {
                mobileMenu.classList.toggle("hidden");

                // Remove the toggle for overflow-hidden on body
                // document.body.classList.toggle("overflow-hidden");

                // Instead, set a fixed height and disable scrolling on the menu
                if (!mobileMenu.classList.contains("hidden")) {
                    mobileMenu.style.height = "100vh";
                    mobileMenu.style.overflowY = "auto";
                    document.body.style.overflow = "hidden";
                    mobileMenuButton.innerHTML = `
                    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2 2L19 19" stroke="#222C49" stroke-width="3" stroke-linecap="round"/>
                        <path d="M2 19L19 2" stroke="#222C49" stroke-width="3" stroke-linecap="round"/>
                    </svg>
                    `;
                } else {
                    mobileMenu.style.height = "";
                    mobileMenu.style.overflowY = "";
                    document.body.style.overflow = "";
                    mobileMenuButton.innerHTML = `
                    <svg width="21" height="15" viewBox="0 0 21 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <line y1="1.5" x2="21" y2="1.5" stroke="#222C49" stroke-width="3"/>
                        <line y1="7.5" x2="21" y2="7.5" stroke="#222C49" stroke-width="3"/>
                        <line y1="13.5" x2="21" y2="13.5" stroke="#222C49" stroke-width="3"/>
                    </svg>
                    `;
                }
            });

            // Close mobile menu on window resize (e.g., when switching to desktop view)
            window.addEventListener("resize", function () {
                if (window.innerWidth >= 768) {
                    // md breakpoint
                    mobileMenu.classList.add("hidden");
                    mobileMenu.style.height = "";
                    mobileMenu.style.overflowY = "";
                    document.body.style.overflow = "";
                    mobileMenuButton.innerHTML = `
                    <svg width="21" height="15" viewBox="0 0 21 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <line y1="1.5" x2="21" y2="1.5" stroke="#222C49" stroke-width="3"/>
                        <line y1="7.5" x2="21" y2="7.5" stroke="#222C49" stroke-width="3"/>
                        <line y1="13.5" x2="21" y2="13.5" stroke="#222C49" stroke-width="3"/>
                    </svg>
                    `;
                }
            });
        }
    });

    // Desktop dropdowns
    const dropdowns = document.querySelectorAll("[data-dropdown]");
    let activeDropdown = null;

    function openDropdown(dropdown) {
        const content = dropdown.querySelector("[data-dropdown-content]");
        const button = dropdown.querySelector("button");
        if (content) {
            content.classList.remove("hidden");
            button.classList.add("dropdown-active");
            activeDropdown = dropdown;
        }
    }

    function closeDropdown(dropdown) {
        const content = dropdown.querySelector("[data-dropdown-content]");
        const button = dropdown.querySelector("button");
        if (content) {
            content.classList.add("hidden");
            button.classList.remove("dropdown-active");
            if (activeDropdown === dropdown) {
                activeDropdown = null;
            }
        }
    }

    dropdowns.forEach((dropdown) => {
        const button = dropdown.querySelector("button");
        const content = dropdown.querySelector("[data-dropdown-content]");
        let timeoutId = null;

        if (!button || !content) return;

        // Desktop hover functionality
        dropdown.addEventListener("mouseenter", () => {
            if (timeoutId) {
                clearTimeout(timeoutId);
                timeoutId = null;
            }
            if (activeDropdown && activeDropdown !== dropdown) {
                closeDropdown(activeDropdown);
            }
            openDropdown(dropdown);
        });

        dropdown.addEventListener("mouseleave", () => {
            timeoutId = setTimeout(() => closeDropdown(dropdown), 300);
        });

        // Desktop click functionality
        button.addEventListener("click", (e) => {
            e.stopPropagation();
            if (content.classList.contains("hidden")) {
                if (activeDropdown) closeDropdown(activeDropdown);
                openDropdown(dropdown);
            } else {
                closeDropdown(dropdown);
            }
        });
    });

    // Close dropdown when clicking outside
    document.addEventListener("click", () => {
        if (activeDropdown) {
            closeDropdown(activeDropdown);
        }
    });

    const mobileAccordions = document.querySelectorAll(".mobile-accordion");

    mobileAccordions.forEach((accordion) => {
        const button = accordion.querySelector("button");
        const content = accordion.querySelector("div:not(:first-child)"); // Get the content div
        const arrow = button.querySelector("svg");

        button.addEventListener("click", () => {
            // For debugging

            // Instead of toggling, let's manage two different class lists
            if (content.classList.contains("hidden")) {
                content.className = "flex flex-col py-4"; // Show state
            } else {
                content.className = "flex flex-col py-4 hidden"; // Hide state
            }


            // Update arrow rotation
            arrow.style.transform = content.classList.contains("hidden")
                ? ""
                : "rotate(180deg)";
        });
    });
})();

/* Add lightbox to gallery images */
(function () {
    lightbox(
        ".kg-image-card > .kg-image[width][height], .kg-gallery-image > img"
    );
})();

/* Responsive video in post content */
(function () {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        ".gh-content object",
        ".gh-content embed",
    ];
    reframe(document.querySelectorAll(sources.join(",")));
})();

/* Turn the main nav into dropdown menu when there are more than 5 menu items */
(function () {
    dropdown();
})();

/* Infinite scroll pagination */
(function () {
    if (
        !document.body.classList.contains("home-template") &&
        !document.body.classList.contains("post-template")
    ) {
        pagination();
    }
})();

/* Responsive HTML table */
(function () {
    const tables = document.querySelectorAll(
        ".gh-content > table:not(.gist table)"
    );

    tables.forEach(function (table) {
        const wrapper = document.createElement("div");
        wrapper.className = "gh-table";
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();

(function () {
    document.addEventListener("DOMContentLoaded", function () {
        const form = document.getElementById("emailForm");
        const emailInput = document.getElementById("emailInput");
        const submitButton = document.getElementById("submitButton");
        const statusMessage = document.getElementById("statusMessage");

        form.addEventListener("submit", async function (e) {
            e.preventDefault();
            submitButton.disabled = true;
            submitButton.textContent = "Submitting...";
            statusMessage.textContent = "";

            const email = emailInput.value;

            try {
                const response = await fetch("/api/newsletter-subscription", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        email: email,
                        currentPageUrl: window.location.href,
                    }),
                });

                const data = await response.json();

                if (data.success) {
                    statusMessage.textContent = "Email submitted successfully!";
                    statusMessage.style.color = "green";
                    emailInput.value = "";
                } else {
                    throw new Error(data.error || "Submission failed");
                }
            } catch (error) {
                console.error("Submission error:", error);
                statusMessage.textContent =
                    "An error occurred. Please try again.";
                statusMessage.style.color = "red";
            } finally {
                submitButton.disabled = false;
                submitButton.textContent = "Submit";
            }
        });
    });
})();
